import React, { Component } from 'react'
import Linkedin from './icon_in.svg'
import FaceBook from './icon_fb.svg'
import Wechat from './icon_wechat.svg'
import Mail from './icon_mail.svg'
import Sign from './sign.svg'
import Woosik from './woosik.jpg'
import HomeAboutQR from './HomeAboutQR'


export default class HomeMobile extends Component {

    constructor() {
        super()
        this.state = {
            isQR : false
        }
    }

    closeFx = () => {

        this.setState(
            { isQR : false }
        )
    }

    openFx = () => {

        this.setState(
            { isQR : true }
        )
    }


    render() {

        return (

            <React.Fragment>

			{ this.state.isQR ? <HomeAboutQR closeMe={this.closeFx} /> : null }


                <div id='MHomeHead'>
                	<span>FLY AWAY</span>
                </div>

                    
                    <div id='MHomeBody'>

                        <span>
                        Thanks for visiting my site!<br />
                        This site was built for my personal purpose. So, there are only few contents for visitors like you.<br />
                        However, If you have something to ask, please visit my SNS.
                        </span>

                        <div id='MHomePic'>
                            <img id='picture' src={Woosik} alt='woosik' />
                            <img id='sign' src={Sign} alt='RYU woosik' />
                        </div>

                    <div id='MHomeFoot'>
                        <a href='https://www.linkedin.com/in/chancehouse/'>
                            <img src={Linkedin} alt='LinkedIn' />
                        </a>

                        <a href='https://www.facebook.com/redcomma'>
                            <img src={FaceBook} alt='FaceBook' />
                        </a>

                        <img src={Wechat} onClick={this.openFx} alt='WeChat' />

                        <a href='mailto:ryuwoosil@gmail.com'>
                            <img src={Mail} alt='email' />
                        </a>
                    </div>
                </div>                    

            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/home/HomeMobile.js